var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSpinnerLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_spinner_line",
    "data-name": "ic_spinner_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M0 35a35 35 0 0 0 35 35v-5a30 30 0 1 1 0-60V0A35 35 0 0 0 0 35z",
    className: "cls-1",
    "data-name": "Path 13"
  }))));
}
export default __webpack_public_path__ + "static/media/ic_spinner_line.012129a2.svg";
export { SvgIcSpinnerLine as ReactComponent };